import Blue from "~/core";

new Blue({
	name: 'Accordion',
	selector: ".accordion",
	setup(accordion) {
    const items = [...accordion.querySelectorAll('.accordion__item')];
    const toggleObjects = [];

    items.forEach(container => {
      let trigger = container.querySelector('.accordion__trigger')
      let content = container.querySelector('.accordion__inner')
      let config = {
        container,
        trigger,
        content,
				necessaryParentSelector: ".accordion"
      }
			toggleObjects.push(new this.$toggle(config));
    });
		//toggleObjects[0].toggle();
	}
});